import { Link, Paper, Stack, styled, withCursorInteractiveStyles } from '@lingoda/ui';
import { studentChallengePath } from '@lingoda/router';
import { getChallengeStatus, getChallengeStatusText, getChallengeTexts } from '../../utils';
import { type Prize } from '../../types';
import { ActiveChallengeWidgetHeader } from './ActiveChallengeWidgetHeader';
import { JoinedChallengeBlock } from './JoinedChallengeBlock';

interface Props {
    challengeName: string;
    startDate: string;
    endDate: string;
    prizes: ReadonlyArray<Prize>;
    completedActivities: number;
    challengeIconUrl: string | undefined;
    title: string;
}

export const ActiveChallengeWidgetJoined = ({
    challengeName,
    startDate,
    endDate,
    prizes,
    completedActivities,
    challengeIconUrl,
    title,
}: Props) => {
    const status = getChallengeStatus(startDate, endDate);
    const statusText = getChallengeStatusText(status, startDate, endDate);
    const { subtitle } = getChallengeTexts(challengeName, startDate);

    return (
        <PaperLink component={Link} to={studentChallengePath({ challengeName })}>
            <Stack spacing={2}>
                <ActiveChallengeWidgetHeader
                    subtitle={subtitle}
                    title={title}
                    iconUrl={challengeIconUrl}
                    statusText={statusText}
                />
                <JoinedChallengeBlock
                    challengeName={challengeName}
                    startDate={startDate}
                    prizes={prizes}
                    completedActivities={completedActivities}
                />
            </Stack>
        </PaperLink>
    );
};

const PaperLink = styled(Paper)(({ theme }) =>
    withCursorInteractiveStyles(true)({
        padding: theme.spacing(3),
        textDecoration: 'none',
        color: 'inherit',
        ':hover': {
            color: 'inherit',
        },
    }),
) as typeof Paper; // `as` to retain `component` property
